import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import type { UpsertJobOfferInputDTO } from '@/backend/modules/career/endpoints/mutations/upsert-job-offer/input.dto';
import { LightCard } from '@/frontend/design-system/data-display/Card';
import { Field, Label } from '@/frontend/design-system/forms/Fieldset';
import { Input } from '@/frontend/design-system/forms/Input';
import { Switch } from '@/frontend/design-system/forms/Switch';
import { H3 } from '@/frontend/design-system/typography/Heading';
import type { JobOfferDTO } from '../../../page';
export type EmploymentContractProps = {
  jobOffer?: JobOfferDTO;
};
export function EmploymentContract(t0) {
  const $ = _c(41);
  const {
    jobOffer
  } = t0;
  const [isUoP, setIsUoP] = useState(Boolean(jobOffer?.salary?.uop));
  const [isB2B, setIsB2B] = useState(Boolean(jobOffer?.salary?.b2b));
  const [isUZ, setIsUZ] = useState(Boolean(jobOffer?.salary?.uz));
  const {
    register
  } = useFormContext();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <H3>Stawka i rodzaj umowy</H3>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setIsUoP(_temp);
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== isUoP) {
    t3 = <Switch checked={isUoP} onChange={t2} />;
    $[2] = isUoP;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Label>UoP</Label>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3) {
    t5 = <Field className="flex w-18 flex-row items-center gap-x-3">{t3}{t4}</Field>;
    $[5] = t3;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== isUoP || $[8] !== register) {
    t6 = isUoP && <Field className="flex flex-row items-center gap-x-3"><Label>Stawka</Label><Input className="mb-2 w-72" {...register("salary.uop")} /></Field>;
    $[7] = isUoP;
    $[8] = register;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5 || $[11] !== t6) {
    t7 = <div className="flex h-14 flex-row items-center gap-6">{t5}{t6}</div>;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => setIsB2B(_temp2);
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== isB2B) {
    t9 = <Switch checked={isB2B} onChange={t8} />;
    $[14] = isB2B;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Label>B2B</Label>;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t9) {
    t11 = <Field className="flex w-18 flex-row items-center gap-x-3">{t9}{t10}</Field>;
    $[17] = t9;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== isB2B || $[20] !== register) {
    t12 = isB2B && <Field className="flex flex-row items-center gap-x-3"><Label>Stawka</Label><Input className="mb-2 w-72" {...register("salary.b2b")} /></Field>;
    $[19] = isB2B;
    $[20] = register;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t11 || $[23] !== t12) {
    t13 = <div className="flex h-14 flex-row items-center gap-6">{t11}{t12}</div>;
    $[22] = t11;
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = () => setIsUZ(_temp3);
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== isUZ) {
    t15 = <Switch checked={isUZ} onChange={t14} />;
    $[26] = isUZ;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <Label>UZ</Label>;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== t15) {
    t17 = <Field className="flex w-18 flex-row items-center gap-x-3">{t15}{t16}</Field>;
    $[29] = t15;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] !== isUZ || $[32] !== register) {
    t18 = isUZ && <Field className="flex flex-row items-center gap-x-3"><Label>Stawka</Label><Input className="mb-2 w-72" {...register("salary.uz")} /></Field>;
    $[31] = isUZ;
    $[32] = register;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  let t19;
  if ($[34] !== t17 || $[35] !== t18) {
    t19 = <div className="flex h-14 flex-row items-center gap-6">{t17}{t18}</div>;
    $[34] = t17;
    $[35] = t18;
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  let t20;
  if ($[37] !== t13 || $[38] !== t19 || $[39] !== t7) {
    t20 = <LightCard className="flex flex-col gap-4 p-6">{t1}{t7}{t13}{t19}</LightCard>;
    $[37] = t13;
    $[38] = t19;
    $[39] = t7;
    $[40] = t20;
  } else {
    t20 = $[40];
  }
  return t20;
}
function _temp3(prev_1) {
  return !prev_1;
}
function _temp2(prev_0) {
  return !prev_0;
}
function _temp(prev) {
  return !prev;
}